class DynamicListingClass {
  $root;
  $popup;
  $overlay;
  $slider;

  timeout;
  filters = {};
  sliderInstance;

  // Configuration
  cfg;
  contentMode;
  filterMode = "server";
  showElem = 8;
  moreButton = false;
  subcategorySwap = false;
  type;
  cinemaid;
  categoryid;

  constructor($root) {
    if (!$root) return;

    this.$root = $root;
    this.$popup = this.$root.find("[data-dlisting-filterpopup]");
    this.$overlay = this.$root.find("[data-dlisting-filterpopup-overlay]");
    this.$slider = this.$root.find("[data-dlisting-slider]");

    this.type = this.$root.data("dlisting-type") || "";
    this.cinemaid = this.$root.data("dlisting-cinemaid") || "";
    this.categoryid = this.$root.data("dlisting-categoryid") || "";
    this.cfg = this.$root.data("dlisting-cfg");
    this.contentMode = this.$root.data("dlisting-contentmode") || "tiles";
    this.filterMode = this.$root.data("dlisting-filtermode") || "server";
    this.showElem = this.$root.data("dlisting-showelem") || 8;
    this.moreButton = this.$root.data("dlisting-morebutton") || false;

    this.init();
    this.addEvents();
  }

  init() {
    const _this = this;

    this.delayedEvent(() => {});

    this.$root.find("[data-dlisting-filters-clear]").hide();

    this.initFromUrl();

    if (
      this.contentMode === "slider" &&
      !$("[data-dlisting-slider]").hasClass("is-initialized")
    ) {
      this.initSlider();
    }

    if ($("[data-dlisting-subcategory-swap]").length > 0) {
      this.subcategorySwap = true;
    }

    $("[data-dlisting-active-day-btn] > button").addClass("active");

    this.refreshSubcategoryOptions();
    this.setTodayDay();
    this.showRangeDatepicker();

    // Filters date range
    $("[data-datepicker-range-start]").change(function () {
      _this.setMinDate($(this).val());
    });

    $("[data-datepicker-range]").on("change", function () {
      _this.calendarRange();
    });

    // Blocking sending request when clicking on the calendar options
    $("[data-dlisting-days-select]").on("change", function (e) {
      if ($(this).find("option:selected").val() === "") {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    $(window).bind("popstate", () => {
      this.initFromUrl();
    });

  }

  addEvents() {
    const _this = this;

    // Filters - clear all
    this.$root.on("click", "[data-dlisting-filters-clear]", function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.clearFilters();
      _this.setTodayDay();
    });

    // Filters - clear single
    this.$root.on("click", "[data-dlisting-filter-clear]", function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.clearFilter($(this).data("dlisting-filter-clear"));
    });

    // Filters - deselect single value
    this.$root.on("click", "[data-dlisting-filter-deselect]", function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.removeListFilterItem(
        $(this).data("dlisting-filter-deselect"),
        $(this).data("dlisting-filter-deselect-value")
      );
    });

    // Filters - toogle click event
    this.$root.on("click change", "[data-dlisting-filter]", function (e) {
      _this.filterEvent($(this), e.type);
    });

    // Filters popup - open
    this.$root.on("click", "[data-dlisting-filterpopup-open]", function (e) {
      e.preventDefault();
      _this.showMobileFiltersPopup();
    });

    // Filters popup - close
    this.$popup.on("click", "[data-dlisting-filterpopup-close]", function (e) {
      e.preventDefault();
      _this.hideMobileFiltersPopup();
    });
  }

  /* --------------------------------------------------------- FILTRATION --- */

  filterEvent($el, eventType) {
    const tagName = $el.prop("tagName");
    if (
      (tagName === "SELECT" || $el.is('input[type="date"]')) &&
      eventType === "click"
    )
      return;

    const filterName = $el.data("dlisting-filter");
    const filterValue =
      tagName === "SELECT" || $el.is('input[type="date"]')
        ? $el.val()
        : $el.data("dlisting-filter-value");
    const filterType = $el.data("dlisting-filter-type");

    switch (filterType) {
      case "string":
        this.setStringFilter(filterName, String(filterValue));
        break;

      case "list":
        this.toggleListFilterItem(
          filterName,
          String(filterValue),
          $el.data("dlisting-filter-forcealone")
        );
        break;
    }
  }

  setStringFilter(name, value) {
    if (!value) {
      this.clearFilter(name);
    } else {
      this.setFilter(name, value);
    }
  }

  removeListFilterItem(name, value) {
    const valueArray = this.filters[name] ?? [];
    const i = valueArray.indexOf(value);
    if (i !== -1) {
      this.filters[name].splice(i, 1);
    }

    if (valueArray.length > 0) {
      this.setFilter(name, valueArray);
    } else {
      this.clearFilter(name);
    }
  }

  toggleListFilterItem(name, value, forceAlone = false) {
    let valueArray = this.filters[name] ?? [];
    const i = valueArray.indexOf(value);
    if (i !== -1) {
      this.filters[name].splice(i, 1);
    } else {
      if (forceAlone) {
        valueArray = [value];
      } else {
        valueArray.push(value);
      }
    }

    // Prepare exclude list
    if (valueArray.length > 0) {
      this.setFilter(name, valueArray);
    } else {
      this.clearFilter(name);
    }
  }

  setFilter(name, value) {
    this.filters[name] = value;
    this.filter();
    this.refreshFiltersState();
  }

  clearFilter(name) {
    if (!name || this.filters[name] === undefined) return;
    delete this.filters[name];
    this.filter();
    this.refreshFiltersState();
  }

  clearFilters() {
    if (Object.keys(this.filters ?? {}).length === 0) return;
    this.filters = {};
    this.filter();
    this.refreshFiltersState();

    $("[data-filtratindays-date-range]").hide();
  }

  refreshFiltersState() {
    $("[data-dlisting-filter]").each((i, el) => {
      const tagName = $(el).prop("tagName");
      const name = $(el).data("dlisting-filter");
      const type = $(el).data("dlisting-filter-type");
      const value = String($(el).data("dlisting-filter-value"));
      const filterValue = this.filters[name];
      let active = false;

      switch (type) {
        case "string":
          if (value === filterValue) {
            active = true;
          }
          break;

        case "list":
          if ((filterValue ?? []).includes(value)) {
            active = true;
          }
          break;
      }

      if (tagName === "SELECT") {
        if (name === 'date') {
          if (filterValue) {
            setTimeout(() => {
              if (filterValue.split(',').length > 1) {
                if ($(el).find(`option[value="${filterValue}"]`).length > 0) {
                  $(el).val(filterValue);
                } else {
                  $(el).find('[data-filtratindays-calendar]').prop('selected',true)
                  this.$root.find("[data-filtratindays-date-range]").show();
                  this.$root.find('[data-datepicker-range-start]').val(filterValue.split(',')[0]);
                  this.$root.find('[data-datepicker-range-end]').val(filterValue.split(',')[1]);
                }
                
              } else {
                $(el).val(filterValue);
              }
            }, 100);
          }
        } else {
          setTimeout(() => {
            $(el).val(filterValue);
          }, 100);
        }
        
        
      }

      $(el).toggleClass("active", active);
    });

    if (Object.keys(this.filters ?? {}).length === 0) {
      this.$root.find("[data-dlisting-filters-clear]").fadeOut(100);
    } else {
      this.$root.find("[data-dlisting-filters-clear]").fadeIn(100);
    }

    let filterCount = 0;

    Object.keys(this.filters).forEach((key) => {
      if (key === 'subcategory') {
        filterCount += this.filters[key].length;
      } else {
        filterCount += 1;
      } 
    }); 

    if ($(window).width() < 992) {  
      $('[data-dlisting-quantity-box]').find('.btnQuantity').text(filterCount);
    }

    this.updateUrl();
  }


  updateUrl() {
    if (this.$root.data("dlisting-homepage") !== undefined) return;

    const params = [];
    Object.keys(this.filters).forEach((key) => {
      if (Array.isArray(this.filters[key])) {
        params.push(`${key}=${this.filters[key].join(',')}`)
      } else {
        params.push(`${key}=${this.filters[key]}`)
      }  
    });

    const hash = params.join('&');
    if (window.location.hash !== `#${hash}`) {
      window.history.pushState({}, '', `${window.location.pathname}#${hash}`);
    }
  }

  initFromUrl() {
    if (!window.location.hash && this.$root.data("dlisting-homepage") !== undefined) return;
    let urlParams = {}

    window.location.hash.replace('#', '').split('&').forEach((el) => {
      const [name, value] = el.split('=');
      if (value) {
        urlParams[name] = String(value);
      }
    })

    const filters = [];
    this.$root.find('[data-dlisting-filter]').each((i, el) => {
      const name = $(el).data('dlisting-filter');
      const type = $(el).data('dlisting-filter-type');
      const value = urlParams[name];
      if (filters.includes(name) || !value) return;
      
      switch (type) {
        case 'string':
          this.filters[name] = value;
          break;
        
        case 'list':
          this.filters[name] = value ? value.split(',') : [];
          break;
      }
    });

    if (Object.keys(this.filters).length > 0) {
      this.filter();
      this.refreshFiltersState();
    }
  }

  setTodayButtonActive() {
    $("[data-dlisting-calendar] li:first-of-type button").addClass("active");
  }

  showRangeDatepicker() {
    const _this = this;

    $("[data-dlisting-days-select]").on("change", function () {
      if ($(this).find("option[data-filtratindays-calendar]").is(":selected")) {
        $("[data-filtratindays-date-range]").show();
      } else {
        $("[data-filtratindays-date-range]").hide();
        $(this).find("option[data-filtratindays-calendar]").attr("value", "");
        _this.setTodayDay();
      }
    });
  }

  calendarRange() {
    var dateStart = $("[data-datepicker-range-start]").val(),
      dateEnd = $("[data-datepicker-range-end]").val(),
      between = [];

    between = dateEnd !== dateStart ? `${dateStart},${dateEnd}` : dateStart;

    $("[data-dlisting-days-select]")
      .find("option[data-filtratindays-calendar]")
      .attr("value", between)
      .end()
      .val(between)
      .trigger("change");
  }

  setMinDate($startDateVal) {
    const date = new Date($startDateVal);
    var tomorrow = this.addOneDay(date),
      tomorrowDay = (
        tomorrow.getDate() < 10 ? "0" + tomorrow.getDate() : tomorrow.getDate()
      ).toString(),
      tomorrowMonth = (
        tomorrow.getMonth() + 1 < 10
          ? "0" + (tomorrow.getMonth() + 1)
          : tomorrow.getMonth() + 1
      ).toString(),
      tomorrowYear = tomorrow.getFullYear().toString(),
      tomorrowFullDate = tomorrowYear + "-" + tomorrowMonth + "-" + tomorrowDay;


    $("[data-datepicker-range-end]")
      .attr("min", $startDateVal.toString())
      .val(tomorrowFullDate);
  }

  addOneDay(date = new Date()) {
    date.setDate(date.getDate() + 1);

    return date;
  }

  delayedEvent(callback) {
    if (this.timeout) clearTimeout(this.timeout);

    this.timeout = setTimeout(callback, 1000);
  }

  /* ------------------------------------------------------ FILTERS POPUP --- */

  showMobileFiltersPopup() {
    if (!this.$popup) return;

    this.$popup.addClass("expanded");
    $(this).attr("aria-expanded", "true");
    this.$overlay.addClass("show");
    $("body").addClass("showOverlay");

    trapFocus("#filtersPanel");
  }

  hideMobileFiltersPopup() {
    if (!this.$popup) return;

    this.$popup.removeClass("expanded");
    $(this).attr("aria-expanded", "false");
    this.$overlay.removeClass("show");
    $("body").removeClass("showOverlay");
  }

  /* ------------------------------------------------------ DATA FETCHING --- */
  getRequestUrl() {
    // ADRES DO TESTOW
    // return 'http://dev01.araw.protnet.pl/~dszulik/front/proxy/go/get/offers/';

    switch ($("body").attr("data-main")) {
      case "go":
        return "get/offers/"; 
  
      default:
        return "/go/get/offers/";
    }
  }

  getQueryParams() {
    let params = ["format=html"];

    if (this.contentMode === "slider") {
      params.push(`listType=${this.contentMode}`);
    }

    if (this.type) {
      params.push(`listType=${this.type}`);
    }

    if (this.cinemaid) {
      params.push(`placeId=${this.cinemaid}`);
    }

    Object.keys(this.filters).forEach((key) => {
      if (Array.isArray(this.filters[key])) {
        params.push(`${key}=${this.filters[key].join(",")}`);
      } else {
        params.push(`${key}=${this.filters[key]}`);
      }
    });

    if (!params.find((el) => el.startsWith("category=")) && this.categoryid) {
      params.push(`category=${this.categoryid}`);
    }

    return `?${params.join("&")}`;
  }

  filter() {
    if (this.filterMode === "server") {
      this.serverSideRequest();
    } else {
      this.browserSideFilter();
    }
  }

  serverSideRequest() {
    this.delayedEvent(() => {
      $.ajax({
        method: "GET",
        url: `${this.getRequestUrl()}${this.getQueryParams()}`,
        beforeSend: () => {
          this.showLoader();
        },
        success: (data) => {
          if (this.contentMode === "slider") {
            this.refreshSlider(data);
          } else {
            this.replaceContent(data);
          }
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.error({ jqXHR, textStatus, errorThrown });
        },
        complete: () => {
          this.hideLoader();
        },
      });
    });
  }

  showLoader() {
    this.$root.find("[data-dlisting-loader]").addClass("loading");
  }

  hideLoader() {
    this.$root.find("[data-dlisting-loader]").removeClass("loading");
  }

  replaceContent(data) {
    this.$root.find("[data-dlisting-content]").html(data);
    this.displayDummyPlug();
  }

  /* ------------------------------------------------- BROWSER FILTRATION --- */

  browserSideFilter() {
    this.$root.find("[data-dlisting-item]").each((i, el) => {
      if (this.meetsBrowserSideFilters($(el))) {
        $(el).removeClass("hideElem");
      } else {
        $(el).addClass("hideElem");
      }
    });

    this.displayDummyPlug();
    this.refreshCalendarCardVisibility();
  }

  refreshCalendarCardVisibility() {
    this.$root.find("[data-dlisting-calendarcard]").each((i, el) => {
      const cardId = $(el).data("dlisting-calendarcard");
      if (
        this.$root.find(`[data-dlisting-calendarcard-item="${cardId}"]:visible`)
          .length > 0
      ) {
        $(el).removeClass("hideElem");
      } else {
        $(el).addClass("hideElem");
      }
    });
  }

  meetsBrowserSideFilters($el) {
    if (!$el || !$el.data("dlisting-item-category")) return false;
    if (Object.keys(this.filters ?? {}).length === 0) return true;

    const categories = String($el.data("dlisting-item-category") || "").split(
      ","
    );

    if (this.filters.category || this.filters.subcategory) {
      const filterCategories = []
        .concat(this.filters.category ?? [], this.filters.subcategory ?? [])
        .map((val) => String(val));

      for (let i = 0; i < filterCategories.length; i += 1) {
        if (!categories.includes(filterCategories[i])) return false;
      }
    }

    if (this.filters.date) {
      const timestamp = new Date(this.filters.date).getTime();
      if (timestamp !== new Date($el.data("dlisting-item-startdate")).getTime())
        return false;
    }

    return true;
  }

  displayDummyPlug() {
    const resultBoxPadding =
      $("window").width() > 767 ? "35px 33px 8px" : "25px";
    const removePaddingBox =
      $("window").width() > 767 ? "10px 0 20px 0" : "25px";

    if ($("[data-dlisting-item]:visible").length > 0) {
      $("[data-dlisting-dummyplug]").hide();
      $("[data-dlisting-results-box]").css("padding", resultBoxPadding);
      $("[data-dlisting-remove-padding]").css("padding", removePaddingBox);
      $("[data-dlisting-white-bg]").css("background-color", "#f2f2f2");

      if ($(window).width() < 768) {
        $("[data-dlisting-results-box]").css("background-color", "#ffffff");
      }
    } else {
      $("[data-dlisting-dummyplug]").show();
      $("[data-dlisting-results-box], [data-dlisting-remove-padding]").css(
        "padding",
        "0"
      );
      $("[data-dlisting-white-bg]").css("background-color", "#ffffff");
    }
  }

  /* ------------------------------------------------ SUBCATEGORY DISPLAY --- */

  refreshSubcategoryOptions() {
    if (this.subcategorySwap) {
      $("[data-dlisting-select-category-switch]")
        .empty()
        .html($("[data-dlisting-subcategory-download]").html());
    }
  }

  /* ------------------------------------------------------- DATEPICKER --- */

  setTodayDay() {
    var d = new Date();
    var today =
      d.getFullYear() +
      "-" +
      ("0" + (d.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + d.getDate()).slice(-2);

    $("[data-datepicker]").val(today);
  }

  /* ------------------------------------------------------------- SLIDER --- */

  initSlider() {
    if (!this.$slider) return;

    if (this.$slider.hasClass("consultation")) {
      this.initSliderA();
    } else {
      this.intiSliderB();
    }
  }

  refreshSlider(content) {
    if (!this.$slider) return;

    if (!this.$slider.hasClass("consultation")) {
      this.refreshSliderB(content);
    }
  }

  initSliderA() {
    this.sliderInstance = new Splide("[data-dlisting-slider]", {
      perPage: 7,
      perMove: 7,
      pagination: false,
      gap: "20px",
      interval: 3000,
      breakpoints: {
        2499: {
          perPage: 6,
          perMove: 6,
        },
        1999: {
          perPage: 5,
          perMove: 5,
        }, 
        1699: {
          perPage: 4,
          perMove: 4,
        },
        1449: {
          perPage: 4,
          perMove: 4,
        },
        1149: {
          perPage: 3,
          perMove: 3,
        },
        890: {
          perPage: 2,
          perMove: 2,
        },
        629: {
          perPage: 1,
          perMove: 1,
          padding: {
            right: 80,
          },
        },
      },
      i18n: {
        prev: "Poprzednie wydarzenia",
        next: "Następne wydarzenia",
        // pageX:  'Strona %s',
      },
    });

    this.sliderInstance.mount();
  }

  intiSliderB() {
    // slider z szerokim zdjeciem
    if (this.$root.find("[data-dlisting-slider]").length > 0) {
      var sliderId = this.$root.find("[data-dlisting-slider]").attr("id");

      this.sliderInstance = new Splide("#" + sliderId, {
        perPage: 6,
        perMove: 6,
        pagination: false,
        gap: "20px",
        interval: 3000,
        breakpoints: {
          1979: {
            perPage: 5,
            perMove: 5,
          },
          1279: {
            perPage: 4,
            perMove: 4,
          },
          991: {
            perPage: 3,
            perMove: 3,
          },
          767: {
            perPage: 2,
            perMove: 2,
          },
          575: {
            perPage: 1,
            perMove: 1,
            padding: {
              right: 80,
            },
          },
        },
        i18n: {
          prev: "Poprzednie wydarzenia",
          next: "Następne wydarzenia",
          // pageX:  'Strona %s',
        },
      });

      this.sliderInstance.mount();
    }

    // slider z wysokim zdjeciem - poster
    if (this.$root.find("[data-dlisting-slider-posterImg]").length > 0) {
      var sliderId = this.$root
        .find("[data-dlisting-slider-posterImg]")
        .attr("id");

      this.sliderInstance = new Splide("#" + sliderId, {
        perPage: 12,
        perMove: 12,
        pagination: false,
        gap: "20px",
        interval: 3000,
        breakpoints: {
          3000: {
            perPage: 11,
            perMove: 1,
          },
          2499: {
            perPage: 9,
            perMove: 9,
          },
          1900: {
            perPage: 8,
            perMove: 8,
          },
          1720: {
            perPage: 7,
            perMove: 7,
          },
          1620: {
            perPage: 6,
            perMove: 6,
          },
          1349: {
            perPage: 5,
            perMove: 5,
          },
          1150: {
            perPage: 4,
            perMove: 4,
          },
          991: {
            perPage: 4,
            perMove: 4,
          },
          768: {
            perPage: 3,
            perMove: 3,
          },
          629: {
            perPage: 2,
            perMove: 1,
            padding: {
              right: 80,
            },
          },
          480: {
            padding: {
              right: 100,
            },
          },
          450: {
            perPage: 1,
            padding: {
              right: 140,
            },
          },
        },
        i18n: {
          prev: "Poprzednie wydarzenia",
          next: "Następne wydarzenia",
          // pageX:  'Strona %s',
        },
      });

      this.sliderInstance.mount();
    }

    // slider z wysokim zdjeciem + opcj wyswietlenia horyzontal img z wyblurowanym tlem - moduł koncertów
    if ($("[data-dlisting-slider-poster-short-img]")) {
      $("[data-dlisting-slider-poster-short-img]").each(function () {
        var sliderId = $(this).attr("id");
        this.sliderInstance = new Splide("#" + sliderId, {
          perPage: 8,
          perMove: 8,
          pagination: false,
          gap: "20px",
          interval: 3000,
          breakpoints: {
            2000: {
              perPage: 7,
              perMove: 7,
            },
            1720: {
              perPage: 6,
              perMove: 6,
            },
            1349: {
              perPage: 5,
              perMove: 5,
            },
            1250: {
              perPage: 4,
              perMove: 4,
            },
            910: {
              perPage: 3,
              perMove: 3,
            },
            629: {
              perPage: 2,
              perMove: 1,
              padding: {
                right: 80,
              },
            },
            480: {
              padding: {
                right: 100,
              },
            },
            450: {
              perPage: 1,
              padding: {
                right: 100,
              },
            },
          },
          i18n: {
            prev: "Poprzednie wydarzenia",
            next: "Następne wydarzenia",
            // pageX:  'Strona %s',
          },
        });

        this.sliderInstance.mount();
      });
    }
  }

  refreshSliderB(content) {
    if (!this.sliderInstance) return;
    const html = $.parseHTML(content);
    this.sliderInstance.remove("li");
    $.each(html, (i, el) => {
      this.sliderInstance.add(el);
    });
  }

  destroySlider() {
    if (!this.$slider) return;
  }
}
